import React, { useState } from 'react';
import { Menu, X, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../mockData';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    } else {
      // If section not found, go to homepage and scroll to section
      window.location.href = `/#${sectionId}`;
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      backgroundColor: 'rgba(26, 28, 27, 0.98)', 
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid var(--border-medium)',
      zIndex: 1000 
    }}>
      {/* Skip to main content for accessibility */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      
      <div className="container">
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          padding: '1rem 0',
          minHeight: '80px'
        }}>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link 
              to="/"
              style={{ 
                textDecoration: 'none',
                color: 'inherit'
              }}
            >
              <div className="heading-3" style={{ 
                color: '#ffffff', 
                fontSize: '1.5rem',
                textTransform: 'none',
                fontWeight: '900',
                cursor: 'pointer'
              }}>
                {companyInfo.name}
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav 
            style={{ display: 'none', alignItems: 'center', gap: '2rem' }} 
            className="desktop-nav"
            role="navigation"
            aria-label="Main navigation"
          >
            <Link 
              to="/"
              className="nav-link"
              style={{ 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer',
                textDecoration: 'none',
                color: '#ffffff'
              }}
              aria-label="Navigate to homepage"
            >
              Home
            </Link>
            <button 
              onClick={() => scrollToSection('services')}
              className="nav-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              aria-label="Navigate to services section"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="nav-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              aria-label="Navigate to about section"
            >
              About
            </button>
            {/* <button 
              onClick={() => scrollToSection('testimonials')}
              className="nav-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              aria-label="Navigate to testimonials section"
            >
              Testimonials
            </button> */} {/* Hidden until we have enough testimonials */}
            <button 
              onClick={() => scrollToSection('contact')}
              className="nav-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Contact
            </button>
            <Link 
              to="/service-areas"
              className="nav-link"
              style={{ textDecoration: 'none' }}
            >
              Service Areas
            </Link>
            <Link 
              to="/blog"
              className="nav-link"
              style={{ textDecoration: 'none' }}
            >
              Blog
            </Link>
            <Link 
              to="/help"
              className="nav-link"
              style={{ textDecoration: 'none' }}
            >
              Help
            </Link>
            <Link to="/portal" className="nav-link" data-testid="nav-portal-link" style={{ textDecoration: 'none' }}>Portal</Link>
            <Link 
              to="/place-order"
              className="nav-link"
              style={{ textDecoration: 'none' }}
            >
              Place Order
            </Link>
          </nav>

          {/* Contact Info & CTA */}
          <div style={{ display: 'none', alignItems: 'center', gap: '1.5rem' }} className="desktop-contact">
            <Link to="/quote" className="btn-primary" data-testid="header-get-quote-link" style={{ textDecoration: 'none' }}>
              Get Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: '#ffffff',
              cursor: 'pointer',
              display: 'block'
            }}
            className="mobile-menu-btn"
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div 
            id="mobile-menu"
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'rgba(26, 28, 27, 0.98)',
              borderBottom: '1px solid var(--border-medium)',
              padding: '2rem 0'
            }}
            role="menu"
            aria-label="Mobile navigation menu"
          >
            <nav style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '1rem',
              alignItems: 'center'
            }}>
              <Link 
                to="/"
                className="nav-link"
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: 'inherit'
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <button 
                onClick={() => scrollToSection('services')}
                className="nav-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="nav-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                About
              </button>
              {/* <button 
                onClick={() => scrollToSection('testimonials')}
                className="nav-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Testimonials
              </button> */} {/* Hidden until we have enough testimonials */}
              <button 
                onClick={() => scrollToSection('contact')}
                className="nav-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Contact
              </button>
              <Link 
                to="/service-areas"
                className="nav-link"
                onClick={() => setIsMenuOpen(false)}
                style={{ textDecoration: 'none' }}
              >
                Service Areas
              </Link>
              <Link 
                to="/blog"
                className="nav-link"
                onClick={() => setIsMenuOpen(false)}
                style={{ textDecoration: 'none' }}
              >
                Blog
              </Link>
              <Link 
                to="/help"
                className="nav-link"
                onClick={() => setIsMenuOpen(false)}
                style={{ textDecoration: 'none' }}
              >
                Help
              </Link>
              <Link to="/portal" className="nav-link" data-testid="mobile-nav-portal-link" onClick={() => setIsMenuOpen(false)} style={{ textDecoration: 'none' }}>Portal</Link>
              <Link 
                to="/place-order"
                className="nav-link"
                onClick={() => setIsMenuOpen(false)}
                style={{ textDecoration: 'none' }}
              >
                Place Order
              </Link>
              <Link to="/quote" className="btn-primary" data-testid="mobile-get-quote-link" style={{ marginTop: '1rem', textDecoration: 'none', textAlign: 'center' }} onClick={() => setIsMenuOpen(false)}>
                Get Quote
              </Link>
            </nav>
          </div>
        )}
      </div>

      <style>{`
        @media (min-width: 768px) {
          .desktop-nav {
            display: flex !important;
          }
          .desktop-contact {
            display: flex !important;
          }
          .mobile-menu-btn {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;